module.exports = __webpack_public_path__ + "static/media/patient-date-icon.d7e3d212.svg";